import { Controller } from "@hotwired/stimulus"

// QRコード発行完了をポーリングで検知し、表示を自動更新するコントローラー
export default class QrPollController extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  declare urlValue: string
  declare intervalValue: number

  private timer: ReturnType<typeof setInterval> | null = null
  private isPolling = false

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  private startPolling() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  private stopPolling() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  private async poll() {
    if (this.isPolling) return
    this.isPolling = true
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/html" }
      })
      if (!response.ok) return

      const html = await response.text()
      this.element.outerHTML = html

      // QRコードが表示された（activeステータス）場合、ポーリング停止
      // 新しいHTMLにdata-controller="qr-poll"が含まれなければ自動停止
    } catch {
      // ネットワークエラーは無視してリトライ
    } finally {
      this.isPolling = false
    }
  }
}
